import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { BannerGridComponent } from './banner-grid.component'
import { LocalDeviceDetectorModule } from 'dmmp-services'
import { SharedModule } from '../shared/shared.module'
import { BannerItemContentComponent } from './desktop/banner-item-content/banner-item-content.component'
import { BannerContentDesktopComponent } from './desktop/banner-content-desktop/banner-content-desktop.component'
import { BannerContentMobileComponent } from './mobile/banner-content-mobile/banner-content-mobile.component'
import { ItemContentComponent } from './item-content/item-content.component'
import { CarouselModule } from 'ngx-owl-carousel-o'
import { BannerSlideComponent } from './desktop/banner-slide/banner-slide.component'
import { RouterModule } from '@angular/router'
import { PipesModule } from '../../pipes/pipes.module'



@NgModule({
  declarations: [
    BannerGridComponent,
    BannerItemContentComponent,
    BannerContentDesktopComponent,
    BannerContentMobileComponent,
    ItemContentComponent,
    BannerSlideComponent
  ],
  imports: [
    CommonModule,
    LocalDeviceDetectorModule,
    SharedModule,
    CarouselModule,
    RouterModule,
    PipesModule
  ],
  exports: [
    BannerGridComponent
  ]
})
export class BannerGridModule { }
